export default "__VITE_ASSET__CSOM6xah__"